import { render } from "./MoreProducts.vue?vue&type=template&id=1028d26d&scoped=true"
import script from "./MoreProducts.vue?vue&type=script&lang=js"
export * from "./MoreProducts.vue?vue&type=script&lang=js"

import "./MoreProducts.vue?vue&type=style&index=0&id=1028d26d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1028d26d"]])

export default __exports__